export default "__VITE_ASSET__BOsTiQI$__"